export default __webpack_public_path__ + "static/media/trending-designs-in-2020.ba99803d.md";